import {Component, OnDestroy, OnInit} from '@angular/core';
import {NewBlank} from '../../../../models/new-blank.model';
import {Standard} from '../../../../models/standard.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AdminService} from '../../../../services/admin.service';
import {UserService} from '../../../../services/user.service';
import * as moment from 'moment';
import {PrefixService} from '../../../../services/frefix.service';
import {AddStandardTypeComponent} from '../../create-standard/modal/add-standard-type/add-standard-type.component';
import {EditStandardTypeComponent} from '../../create-standard/modal/edit-standard-type/edit-standard-type.component';
import {StandardType} from '../../../../models/standard-type.model';
import {StandardTypesService} from '../../../../services/standard-types.service';
import {StepsControllerService} from '../../../../services/steps-controller.service';
import {ConfirmationPopupComponent} from '../../../views/view-group/popups/confirmation-popup/confirmation-popup.component';
import {Router} from '@angular/router';
import {TreeGroupPosService} from '../tree-group-pos-service/tree-group-pos.service';
import {ViewDocxComponent} from '../../../views/view-docx/view-docx.component';
import {ViewDocxService} from '../../../../services/view-docx.service';

@Component({
  selector: 'app-opst-step-one',
  templateUrl: './opst-step-one.component.html',
  styleUrls: ['./opst-step-one.component.css'],
})

export class OpstStepOneComponent implements OnInit {
  formData: FormData = new FormData();
  selectedType: StandardType;
  isLoaded = false;
  groupStandardId: string;
  users: any;
  groups: any;
  groupsHead: any[] = [];
  // disGtn = false;
  selectedGroupObj: any;
  standardNumber: string;
  generadedNumber: string;
  initiator: any;
  status = 'New';
  newBlanks: NewBlank[] = [];
  failedRetrieveEntities = false;
  standard: any;
  stringDate: string;
  userID = this.userService.getLocal().id;
  numberCountToday: number;
  selectedForExecute: any = [];
  selectedForConfirm: any = [];
  selectedGroupForExecute: any = [];
  selectedPosForExecute: any = [];
  selectedPosForEConfirm: any = [];
  selectedGroupHeadForConfirm: any = [];

  hasGroups = false;
  savingStandard = false;

  newRuName = '';
  newEnName = '';
  newRuAn = '';
  newEnAn = '';

  prefixErrorMsg = false;
  standardOkMsg = false;
  standardBack: any;
  tmpCurrentStandard = null;
  foundUser = false;
  foundPos = false;
  foundGroup = false;
  foundUserConfirm = false;
  foundPosConfirm = false;
  foundGroupConfirm = false;
  createAction = true;
  createActionStandardID = '';
  currentUserID: string;
  standardBaseLanguage = '';
  ruDocMsg = false;
  ruPdfMsg = false;
  ruPptMsg = false;
  enDocMsg = false;
  enPdfMsg = false;
  enPptMsg = false;
  ruFileLink = false;
  enFileLink = false;
  isDeletedruDocMsg = true;
  isDeletedruPdfMsg = true;
  isDeletedruPptMsg = true;
  isDeletedenDocMsg = true;
  isDeletedenPdfMsg = true;
  isDeletedenPptMsg = true;
  noTypeError = false;

  // Save here all Groups and Positions
  // private allGroupsAndPositions: any[] = [];
  // Save here selected Groups and Positions
  // private selectedGroupsAndPositions: any[] = [];

  constructor(private userService: UserService,
              private adminService: AdminService,
              private modalService: NgbModal,
              public viewDocxService: ViewDocxService,
              public prefixService: PrefixService,
              private router: Router,
              public standardTypesService: StandardTypesService,
              public stepsControllerService: StepsControllerService,
              public treeGroupPosService: TreeGroupPosService) {
  }

  ngOnInit() {
    this.standardBaseLanguage = this.userService.getLocal().language;
    this.isLoaded = false;

    // GET ALL HEAD'S GROUPS
    this.stepsControllerService.getAllHeadingGroups().subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.groupsHead = response.body;
          if (this.groupsHead.length > 0) {
            this.hasGroups = true;
            this.stepsControllerService.dataStandardHasGroups = true;

            this.groupStandardId = this.groupsHead[0].id;
            this.selectedGroupObj = this.groupsHead[0];

            if (this.stepsControllerService.hasCurrentStandard()) {
              this.setDivisionInitiator(this.stepsControllerService.getCurrentStandard().bindingGroup.id);
            }

            this.initiator = this.userService.getLocal();
            this.isLoaded = true;
            this.retryGroups();

          } else {
            this.hasGroups = false;
            this.stepsControllerService.dataStandardHasGroups = false;

            this.isLoaded = true;
          }
        }
      },
      () => {
        this.failedRetrieveEntities = true;
      },
      () => {
      }
    );

    // Если просто открыть.
    if (!this.stepsControllerService.hasCurrentStandard()) {
      // Data
      this.stringDate = moment().format('DD.MM.YYYY');
    } else {
      // Если зайти со списка!
      this.tmpCurrentStandard = this.stepsControllerService.getCurrentStandard();
      this.stringDate = this.tmpCurrentStandard.creationDate;

      this.newRuName = this.tmpCurrentStandard.ruName;
      this.newEnName = this.tmpCurrentStandard.enName;
      this.newRuAn = this.tmpCurrentStandard.ruAnnotation;
      this.newEnAn = this.tmpCurrentStandard.enAnnotation;

      // Установить выбранными пользователей для исполнения
      if (this.tmpCurrentStandard.linkedUsers.length > 0) {
        for (const userExecute of this.tmpCurrentStandard.linkedUsers) {
          this.selectItem(userExecute);
        }
      }

      // Установить выбранными пользователей для утверждения
      if (this.tmpCurrentStandard.confirmedUsers.length > 0) {
        for (const userForConfirm of this.tmpCurrentStandard.confirmedUsers) {
          this.fieldsChangeTmp(userForConfirm);
        }
      }

      // Установить выбранными группы для утверждения
      if (this.tmpCurrentStandard.confirmedGroups.length > 0) {
        for (const groupForConfirm of this.tmpCurrentStandard.confirmedGroups) {
          this.fieldsChangeGroupHeadTmp(groupForConfirm);
        }
      }

      // Установить выбранными позиции для исполнения
      if (this.tmpCurrentStandard.linkedPositions.length > 0) {
        for (const posExecute of this.tmpCurrentStandard.linkedPositions) {
          this.selectPosItem(posExecute);
        }
      }

      // Установить выбранными позиции для утверждения
      if (this.tmpCurrentStandard.confirmedPositions.length > 0) {
        for (const posForConfirm of this.tmpCurrentStandard.confirmedPositions) {
          this.fieldsChangePosTmp(posForConfirm);
        }
      }

      // Files for step 2
      if (this.tmpCurrentStandard.ruDoc !== null) {
        this.ruDocMsg = true;
      }
      if (this.tmpCurrentStandard.ruPdf !== null) {
        this.ruPdfMsg = true;
      }
      if (this.tmpCurrentStandard.ruPpt !== null) {
        this.ruPptMsg = true;
      }
      if (this.tmpCurrentStandard.enDoc !== null) {
        this.enDocMsg = true;
      }
      if (this.tmpCurrentStandard.enPdf !== null) {
        this.enPdfMsg = true;
      }
      if (this.tmpCurrentStandard.enPpt !== null) {
        this.enPptMsg = true;
      }

      if (this.tmpCurrentStandard.ruFileLink !== null) {
        this.ruFileLink = true;
      }
      if (this.tmpCurrentStandard.enFileLink !== null) {
        this.enFileLink = true;
      }
    }

    this.currentUserID = localStorage.getItem('User');
  }

  openDocModal(docxID, sID) {
    localStorage.setItem('DocxID', docxID);
    localStorage.setItem('DocxSID', sID);

    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxID();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxID();
    });
  }

  openDocModalDOCX(fileLink) {
    localStorage.setItem('fileLink', fileLink);
    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxIDManually();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxIDManually();
    });
  }

  deleteFileDOCX(sid, fileLink, type, docId) {
    this.adminService.deleteTempDocxFileManually(fileLink, sid).subscribe(
      (res: any) => {
        if (type === 'RU_DOC') {
          this.tmpCurrentStandard.ruDoc = null;
          this.tmpCurrentStandard.ruFileLink = null;
          this.ruFileLink = false;
          this.ruDocMsg = false;
          // this.stepsControllerService.dataStandardFormData.delete((type));
          // this.stepsControllerService.unlockStepThree(true);
        } else if (type === 'EN_DOC') {
          this.tmpCurrentStandard.enDoc = null;
          this.tmpCurrentStandard.enFileLink = null;
          this.enFileLink = false;
          this.enDocMsg = false;
          // this.stepsControllerService.dataStandardFormData.delete((type));
          // this.stepsControllerService.unlockStepThree(true);
        }

        if (docId) {
          this.deleteExistFile(type, docId);
        }

      },
      () => {
      }
    );
  }

  deleteExistFile(fileType, fileID) {
    this.isDeletedruDocMsg = false;
    this.isDeletedruPdfMsg = false;
    this.isDeletedruPptMsg = false;
    this.isDeletedenDocMsg = false;
    this.isDeletedenPdfMsg = false;
    this.isDeletedenPptMsg = false;

    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DO_YOU_WANT_TO_DELETE_THIS_STANDARD';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        this.adminService.deleteFileFromStandard(fileID, fileType, {id: this.tmpCurrentStandard.id}).subscribe(
          (response) => {
            if (response.status === 200) {
              switch (fileType) {
                case 'RU_DOC': {
                  this.tmpCurrentStandard.ruDoc = null;
                  this.ruDocMsg = false;
                  this.stepsControllerService.stepThreeDisabled = true;
                  break;
                }
                case 'RU_PPT': {
                  this.tmpCurrentStandard.ruPpt = null;
                  this.ruPptMsg = false;
                  break;
                }
                case 'RU_PDF': {
                  this.tmpCurrentStandard.ruPdf = null;
                  this.ruPdfMsg = false;
                  break;
                }
                case 'EN_DOC': {
                  this.tmpCurrentStandard.enDoc = null;
                  this.enDocMsg = false;
                  break;
                }
                case 'EN_PPT': {
                  this.tmpCurrentStandard.enPpt = null;
                  this.enPptMsg = false;
                  break;
                }
                case 'EN_PDF': {
                  this.tmpCurrentStandard.enPdf = null;
                  this.enPdfMsg = false;
                  break;
                }
              }
              this.isDeletedruDocMsg = true;
              this.isDeletedruPdfMsg = true;
              this.isDeletedruPptMsg = true;
              this.isDeletedenDocMsg = true;
              this.isDeletedenPdfMsg = true;
              this.isDeletedenPptMsg = true;
            }
          },
          () => {
            this.isDeletedruDocMsg = true;
            this.isDeletedruPdfMsg = true;
            this.isDeletedruPptMsg = true;
            this.isDeletedenDocMsg = true;
            this.isDeletedenPdfMsg = true;
            this.isDeletedenPptMsg = true;
          }
        );
      }
    });
  }

  downloadSFile(fileID) {
    this.userService.getFile(fileID).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }
    );
  }

  deleteSBlankFile(blank) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DYWTDTBF';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        this.adminService.deleteBlankFromStandard(blank, {id: this.stepsControllerService.getCurrentStandard().id}).subscribe(
          (response: any) => {
            if (response.status === 200) {
              const index = this.tmpCurrentStandard.blanks.indexOf(blank);
              this.tmpCurrentStandard.blanks.splice(index, 1);
            }
          },
          () => {
          }
        );
      }
    });
  }

  // UPDATE TYPES IN TYPES LIST IN SERVICE
  updateTypes(listOfTypes) {
    if (listOfTypes !== null && listOfTypes !== undefined) {
      this.prefixService.updateTypesList(listOfTypes);
    } else {
      this.prefixService.updateTypesList([]);
    }
  }

  retryGroups() {
    // GET PREFIXES BY GROUP IS
    this.prefixService.getPrefixesForGroup(this.selectedGroupObj.id).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.prefixService.setGroupPrefixex(response.body);
          // UPDATE TYPES LIST
        } else if (response.status === 204) {
          this.prefixService.setGroupPrefixex([]);
          this.prefixService.setSelectedPrefix(null);
        }
      },
      (error) => {
        this.failedRetrieveEntities = true;
      },
      () => {
        // Was in complete()
        this.prefixService.setSelectedPrefix(this.prefixService.getGroupPrefixex()[0]);
        this.setCounterNum(this.prefixService.getGroupPrefixex()[0]);

        if (!this.stepsControllerService.hasCurrentStandard()) {
          if (this.prefixService.getSelectedPrefix()) {
            this.standardNumber = this.prefixService.getSelectedPrefix().name + this.generadedNumber;
          } else {
            if (this.prefixService.getGroupPrefixex().length > 0) {
              this.standardNumber = this.prefixService.getGroupPrefixex()[0].name + this.generadedNumber;
            } else {
              this.standardNumber = this.generadedNumber;
            }
          }
        } else {
          this.standardNumber = this.stepsControllerService.getCurrentStandard().number;
        }
      }
    );

    // GET TYPES BY GROUP ID
    this.standardTypesService.getTypesForGroup(this.selectedGroupObj.id).subscribe(
      (res: any) => {
        if (res.status === 200) {
          // UPDATE TYPES LIST
          this.updateTypes(res.body);
        }
      },
      () => {
      }
    );
    // END GET TYPES BY GROUP ID
  }

  // ПРОВЕРКА ВЫБРАН ЛИ ЭЛЕМЕНТ
  selectItem(user) {
    if (this.isSelectedUser(user)) {
      const index = this.selectedForExecute.findIndex(x => x.id === user.id);
      if (index !== -1) {
        this.selectedForExecute.splice(index, 1);
      }
    } else {
      this.selectedForExecute.push(user);
    }
  }

  selectPosItem(pos) {
    if (this.isSelectedPos(pos)) {
      const index = this.selectedPosForExecute.findIndex(x => x.id === pos.id);
      if (index !== -1) {
        this.selectedPosForExecute.splice(index, 1);
      }
    } else {
      this.selectedPosForExecute.push(pos);
    }
  }

  isSelectedUser(user) {
    this.foundUser = false;
    if (this.selectedForExecute.length > 0) {
      for (const grp of this.selectedForExecute) {
        if (grp.id === user.id) {
          this.foundUser = true;
          break;
        }
      }
    }
    return this.foundUser;
  }

  isSelectedPos(pos) {
    this.foundPos = false;
    if (this.selectedPosForExecute.length > 0) {
      for (const grp of this.selectedPosForExecute) {
        if (grp.id === pos.id) {
          this.foundPos = true;
          break;
        }
      }
    }
    return this.foundPos;
  }

  isSelectedUserConfirm(user) {
    this.foundUserConfirm = false;
    if (this.selectedForConfirm.length > 0) {
      for (const grp of this.selectedForConfirm) {
        if (grp.id === user.id) {
          this.foundUserConfirm = true;
          break;
        }
      }
    }
    return this.foundUserConfirm;
  }

  isSelectedGroupHeadConfirm(group) {
    this.foundGroupConfirm = false;
    if (this.selectedGroupHeadForConfirm.length > 0) {
      for (const grp of this.selectedGroupHeadForConfirm) {
        if (grp.id === group.id) {
          this.foundGroupConfirm = true;
          break;
        }
      }
    }
    return this.foundGroupConfirm;
  }

  isSelectedPosConfirm(pos) {
    this.foundPosConfirm = false;
    if (this.selectedPosForEConfirm.length > 0) {
      for (const grp of this.selectedPosForEConfirm) {
        if (grp.id === pos.id) {
          this.foundPosConfirm = true;
          break;
        }
      }
    }
    return this.foundPosConfirm;
  }

  fieldsChangeTmp(user) {
    if (!this.isSelectedUserConfirm(user)) {
      this.selectedForConfirm.push(user);
    }
  }

  fieldsChangeGroupHeadTmp(group) {
    if (!this.isSelectedGroupHeadConfirm(group)) {
      this.selectedGroupHeadForConfirm.push(group);
    }
  }

  fieldsChangePosTmp(pos) {
    if (!this.isSelectedPosConfirm(pos)) {
      this.selectedPosForEConfirm.push(pos);
    }
  }

  setDivisionInitiator(groupID) {
    const groupObj = this.groupsHead.find(i => i.id === groupID);
    this.selectedGroupObj = groupObj;
    this.groupStandardId = groupID;
    this.retryGroups();
  }

  setNumberPrefix(prefixName) {
    const prefixObj = this.prefixService.getGroupPrefixex().find(i => i.name === prefixName);
    this.prefixService.setSelectedPrefix(prefixObj);
    this.setCounterNum(prefixObj);
  }

  setCounterNum(prefixObj) {
    if (prefixObj) {
      this.prefixService.getCountStandardNumber(prefixObj.id).subscribe(
        (response) => {
          this.numberCountToday = Number(response.body) + 1;
          this.generadedNumber = '.' + this.numberCountToday + '.' + this.stringDate;
        },
        () => {
        }
      );
    } else {
      this.numberCountToday = 1;
      this.generadedNumber = '.' + this.numberCountToday + '.' + this.stringDate;
    }
  }

  // Create new type window
  openAddNewTypeModal() {
    const modalRef = this.modalService.open(AddStandardTypeComponent);
    modalRef.componentInstance.setTypeMainGroup(this.selectedGroupObj);
    modalRef.result.then((result) => {
      if (result === 'ok') {
        this.noTypeError = false;
      }
    });
  }

  // Edit type window
  openEditTypeModal() {
    const modalRef = this.modalService.open(EditStandardTypeComponent);
    modalRef.componentInstance.setTypeMainGroup(this.selectedGroupObj);
  }

  setType(typeID) {
    const typeObj = this.standardTypesService.getTypesList().find(i => i.id === typeID);
    this.standardTypesService.setSelectedType(typeObj);
    this.selectedType = typeObj;
  }

  isValid() {
    if (this.stepsControllerService.getLocalUserLanguage() === 'Ru') {

      if (this.newRuName.trim().length > 0 &&
        this.newRuAn.trim().length > 0 &&
        this.formData.has('RU_DOC') &&
        this.checkListsLengthExecute()) {
        this.stepsControllerService.setDataStandard(this.getDataStandard(), this.formData, this.newBlanks);
        this.stepsControllerService.unlockStepThree(true);
      } else {
        this.stepsControllerService.unlockStepThree(false);
      }
      return (
        this.newRuName.trim().length > 0 &&
        this.newRuAn.trim().length > 0 &&
        this.formData.has('RU_DOC') &&
        this.checkListsLengthExecute());
    }

    if (this.stepsControllerService.getLocalUserLanguage() === 'En') {

      if (this.newEnName.trim().length > 0 &&
        this.newEnAn.trim().length > 0 &&
        this.formData.has('EN_DOC') &&
        this.checkListsLengthExecute()) {
        this.stepsControllerService.setDataStandard(this.getDataStandard(), this.formData, this.newBlanks);
        this.stepsControllerService.unlockStepThree(true);
      } else {
        this.stepsControllerService.unlockStepThree(false);
      }

      return (
        this.newEnName.trim().length > 0 &&
        this.newEnAn.trim().length > 0 &&
        this.formData.has('EN_DOC') &&
        this.checkListsLengthExecute());
    }
  }

  checkListsLengthExecute() {
    return this.treeGroupPosService.isValid();
  }

  qCreateQuest() {
    if (this.standardTypesService.getTypesList().length !== 0) {
      this.noTypeError = false;
      if (this.prefixService.getSelectedPrefix()) {
        const modalRef = this.modalService.open(ConfirmationPopupComponent);
        modalRef.componentInstance.massage = 'Save standard and continue?';

        modalRef.result.then((result) => {
          if (result === 'ok') {
            this.createNewStandard();
          }
        });
      } else {
        this.prefixErrorMsg = true;
      }
    } else {
      this.noTypeError = true;
    }
  }

  createNewStandard() {
    this.stepsControllerService.disGtn = true;
    this.prefixErrorMsg = false;
    this.standardOkMsg = false;
    this.savingStandard = true;

    this.stepsControllerService.dataStandardFilesUploadError = false;
    this.stepsControllerService.dataStandardErrorExists = false;
    this.stepsControllerService.dataStandardErrorCreating = false;

    if (this.stepsControllerService.hasCurrentStandard() &&
      this.stepsControllerService.getCurrentStandard().hasOwnProperty('id')) {
      // if (this.stepsControllerService.getCurrentStandard() !== undefined &&
      //   this.stepsControllerService.getCurrentStandard() !== null) {
      this.createAction = false;
      this.createActionStandardID = this.stepsControllerService.getCurrentStandard().id;
    } else {
      this.createAction = true;
      this.createActionStandardID = '';
    }

    // NEXT Button;
    if (this.stepsControllerService.unlockSThree && this.stepsControllerService.dataStandard) {
      // this.stepsControllerService.createOrUpdateHeadStandard(this.stepsControllerService.dataStandard, true, null)
      this.stepsControllerService.createOrUpdateHeadStandard(this.stepsControllerService.dataStandard, this.createAction, this.createActionStandardID)
        .subscribe(
          (response: any) => {
            if (response.status === 201 || response.status === 200) {
              const standardBck = response.body;
              this.standardBack = standardBck;
              this.uploadFiles();
            } else if (response.status === 208) {
              // 208: Standard with this number already exists;
              this.stepsControllerService.dataStandardErrorExists = true;
              this.stepsControllerService.disGtn = false;
            } else {
              // Standard create error;
              this.stepsControllerService.dataStandardErrorCreating = true;
              this.stepsControllerService.disGtn = false;
            }
          },
          () => {
            // Error: Create standard error;
            this.stepsControllerService.dataStandardErrorCreating = true;

            this.stepsControllerService.disGtn = false;
            this.standardOkMsg = false;
          }
        );

    } else {
      // DEFAULT Button;
      this.stepsControllerService.createOrUpdateHeadStandard(this.getDataStandard(), this.createAction, this.createActionStandardID)
        .subscribe(
          (response: any) => {
            if (response.status === 201 || response.status === 200) {
              const standardBck = response.body;
              this.standardBack = standardBck;
              this.uploadFiles();
            } else if (response.status === 208) {
              // 208: Standard with this number already exists;
              this.stepsControllerService.dataStandardErrorExists = true;
              this.stepsControllerService.disGtn = false;
              this.savingStandard = false;
            } else {
              // Standard create error;
              this.stepsControllerService.dataStandardErrorCreating = true;
              this.stepsControllerService.disGtn = false;
              this.savingStandard = false;
            }
          },
          () => {
            // Error: Create standard error;
            this.stepsControllerService.dataStandardErrorCreating = true;

            this.stepsControllerService.disGtn = false;
            this.standardOkMsg = false;
            this.savingStandard = false;
          }
        );
    }
  }

  private uploadFiles() {
    // NEXT Button;
    if (this.stepsControllerService.unlockSThree && this.stepsControllerService.dataStandard) {
      this.adminService.uploadFiles(this.standardBack, this.stepsControllerService.dataStandardFormData).subscribe(
        (res: any) => {
          this.uploadBlanks(this.standardBack);
        },
        () => {
          // Files upload error message;
          this.stepsControllerService.dataStandardFilesUploadError = true;

          this.stepsControllerService.disGtn = false;
        }
      );

    } else {
      // DEFAULT Button;
      if (this.formData.has('RU_DOC') || this.formData.has('RU_PPT') ||
        this.formData.has('EN_DOC') || this.formData.has('EN_PPT')) {
        // If any file was selected
        this.adminService.uploadFiles(this.standardBack, this.formData).subscribe(
          (res: any) => {
            this.uploadBlanks(this.standardBack);
          },
          () => {
            // Files upload error message;
            this.stepsControllerService.dataStandardFilesUploadError = true;

            this.stepsControllerService.disGtn = false;
            this.savingStandard = false;
          }
        );

      } else {
        this.uploadBlanks(this.standardBack);
      }
    }
  }

  private uploadBlanks(standard: Standard) {
    if (this.stepsControllerService.unlockSThree && this.stepsControllerService.dataStandard) {
      // NEXT Button;
      if (this.stepsControllerService.dataStandardNewBlanks.length > 0) {

        // Check if one or more blanks was selected
        const dataStandardNewBlanksChecked: NewBlank[] = [];
        this.stepsControllerService.dataStandardNewBlanks.forEach(nb => {
          if (nb.formData) {
            if (nb.formData.get('file')) {
              dataStandardNewBlanksChecked.push(nb);
            }
          }
        });

        if (dataStandardNewBlanksChecked.length > 0) {
          // this.adminService.uploadBlank(standard, this.stepsControllerService.dataStandardNewBlanks).subscribe(
          this.adminService.uploadBlank(standard, dataStandardNewBlanksChecked).subscribe(
            (res: any) => {
              this.completeAction();
            }, () => {
              // Files upload error message;
              this.stepsControllerService.dataStandardFilesUploadError = true;

              this.stepsControllerService.disGtn = false;
            }
          );
        } else {
          this.completeAction();
        }
      } else {
        this.completeAction();
      }


    } else {
      // DEFAULT Button;
      if (this.newBlanks.length > 0) {

        // Check if one or more blanks was selected
        const newBlanksChecked: NewBlank[] = [];
        this.newBlanks.forEach(nb => {
          if (nb.formData) {
            if (nb.formData.get('file')) {
              newBlanksChecked.push(nb);
            }
          }
        });

        if (newBlanksChecked.length > 0) {
          // this.adminService.uploadBlank(standard, this.newBlanks).subscribe(
          this.adminService.uploadBlank(standard, newBlanksChecked).subscribe(
            (res: any) => {
              this.completeAction();
            }, () => {
              // Files upload error message;
              this.stepsControllerService.dataStandardFilesUploadError = true;

              this.stepsControllerService.disGtn = false;
              this.savingStandard = false;
            }
          );

        } else {
          this.completeAction();
        }
      } else {
        this.completeAction();
      }
    }
  }

  completeAction() {
    if (this.isValid()) {

      // Убрать это в комменты, когда починятся файлы.
      this.stepsControllerService.setCurrentStandard(this.standardBack);
      this.standardOkMsg = true;
      this.stepsControllerService.stepThreeDisabled = false;
      this.stepsControllerService.activeStep = 3;

      // FOR CONTROL NEXT BUTTON IN 2'nd STEP
      this.stepsControllerService.nextToCreate = false;
      this.stepsControllerService.unlockSThree = false;
      this.stepsControllerService.dataStandard = null;
      this.stepsControllerService.dataStandardFormData = null;
      this.stepsControllerService.dataStandardNewBlanks = null;

      this.stepsControllerService.disGtn = false;
      // Files upload error message;
      this.stepsControllerService.dataStandardFilesUploadError = false;
      this.savingStandard = false;

      this.router.navigate(['/dashboard/create-operating-standard/step-three']);

    } else if (this.stepsControllerService.dataStandard) {

      // Убрать это в комменты, когда починятся файлы.
      this.stepsControllerService.setCurrentStandard(this.standardBack);
      this.standardOkMsg = true;
      this.stepsControllerService.stepThreeDisabled = false;
      this.stepsControllerService.activeStep = 3;

      // FOR CONTROL NEXT BUTTON IN 2'nd STEP
      this.stepsControllerService.nextToCreate = false;
      this.stepsControllerService.unlockSThree = false;
      this.stepsControllerService.dataStandard = null;
      this.stepsControllerService.dataStandardFormData = null;
      this.stepsControllerService.dataStandardNewBlanks = null;

      this.stepsControllerService.disGtn = false;
      // Files upload error message;
      this.stepsControllerService.dataStandardFilesUploadError = false;
      this.savingStandard = false;

      this.router.navigate(['/dashboard/create-operating-standard/step-three']);

    } else {

      this.stepsControllerService.clearCurrentStandard();
      this.standardOkMsg = true;
      this.stepsControllerService.stepOneDisabled = false;
      this.stepsControllerService.stepTwoDisabled = false;
      this.stepsControllerService.activeStep = 1;

      this.stepsControllerService.disGtn = false;
      this.savingStandard = false;
      this.router.navigate(['/dashboard/operating-standards']);
    }
  }

  getDataStandard() {
    const linkedGroups = [];
    if (this.selectedGroupForExecute.length > 0) {
      for (const item of this.selectedGroupForExecute) {
        linkedGroups.push(item.id);
      }
    }

    const confirmedGroups = [];
    if (this.selectedGroupHeadForConfirm.length > 0) {
      for (const item of this.selectedGroupHeadForConfirm) {
        confirmedGroups.push(item.id);
      }
    }

    const linkedUsers = [];
    if (this.selectedForExecute.length > 0) {
      for (const item of this.selectedForExecute) {
        linkedUsers.push(item.id);
      }
    }

    const confirmedUsers = [];
    if (this.selectedForConfirm.length > 0) {
      for (const item of this.selectedForConfirm) {
        confirmedUsers.push(item.id);
      }
    }

    const linkedPositions = [];
    if (this.selectedPosForExecute.length > 0) {
      for (const item of this.selectedPosForExecute) {
        linkedPositions.push(item.id);
      }
    }

    const confirmedPositions = [];
    if (this.selectedPosForEConfirm.length > 0) {
      for (const item of this.selectedPosForEConfirm) {
        confirmedPositions.push(item.id);
      }
    }

    const dataStandard = {
      number: this.prefixService.getSelectedPrefix().name + this.generadedNumber,
      creationDate: this.stringDate,
      authorId: this.initiator.id,
      groupId: this.selectedGroupObj.id,
      ruName: this.newRuName,
      enName: this.newEnName,
      standardType: null,
      ruAnnotation: this.newRuAn,
      enAnnotation: this.newEnAn,
      status: 'NEW',
      linkedGroups: linkedGroups,
      confirmedGroups: confirmedGroups,
      linkedUsers: linkedUsers,
      confirmedUsers: confirmedUsers,
      linkedPositions: linkedPositions,
      confirmedPositions: confirmedPositions,
      language: this.standardBaseLanguage,
      standardDisseminationPositions: this.treeGroupPosService.getReadeForServer()
    };

    if (this.standardTypesService.getSelectedType() !== undefined) {
      dataStandard.standardType = {
        id: this.standardTypesService.getSelectedType().id,
          ruName: this.standardTypesService.getSelectedType().ruName,
          enName: this.standardTypesService.getSelectedType().enName,
      };
    }

    dataStandard.standardDisseminationPositions.forEach(ds => {
      if (ds.onlyHeadConfirm === undefined) {
        ds.onlyHeadConfirm = false;
      }
    });

    if (this.standardBaseLanguage === 'russian') {
      dataStandard.enName = null;
      dataStandard.enAnnotation = null;
    } else if (this.standardBaseLanguage === 'english') {
      dataStandard.ruName = null;
      dataStandard.ruAnnotation = null;
    }

    return dataStandard;
  }

  fileChange(type: string, event) {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      this.formData.set(type, file, file.name);
    } else {
      this.formData.delete(type);
      // And delete TYPE in stepsControllerService for NEXT button
      if (this.stepsControllerService.dataStandardFormData) {
        this.stepsControllerService.dataStandardFormData.delete((type));
      }
    }
  }

  addNewBlank() {
    this.newBlanks.unshift(new NewBlank(null, null, null));
  }

  blanksChange(event, index: number) {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const formData = new FormData();
      formData.append('file', file, file.name);
      this.newBlanks[index].formData = formData;
    }
  }

  deleteBlank(key) {
    if (key > -1) {
      this.newBlanks.splice(key, 1);
    }
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-one/opst-step-one.component.ts